import icon from "images/icons/icon-edit.svg"

export default function EditIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
